import React from 'react';
import ReactDOM from 'react-dom';

import {HashRouter as Router} from "react-router-dom";

import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/styles/site-wide.scss";

import App from './App';
import * as serviceWorker from './serviceWorker';


const root = document.getElementById("root");
ReactDOM.render(
	<Router basename={"/"}>
		<App />
	</Router>,
	root
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
